import {
  JOURNALING_GET_PATH,
  JOURNALING_MASS_FILL_SAVE_PATH,
  JOURNALING_SAVE_PATH,
} from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

import { JournalingRequestData, JournalOptions, MassFillJournalingRequestData } from './types'

class JournalingServiceClass extends AbstractService {
  getJournalData = (tradingLogId: string | null) =>
    this.request<ServerResponse<JournalOptions>>(
      tradingLogId ? `${JOURNALING_GET_PATH}/${tradingLogId}` : JOURNALING_GET_PATH,
      'get',
      true,
      null,
    )

  sendJournalData = (data: JournalingRequestData) =>
    this.request<ServerResponse<number>>(JOURNALING_SAVE_PATH, 'post', true, data)

  sendMassFillJournalData = (data: MassFillJournalingRequestData) =>
    this.request<ServerResponse<never>>(JOURNALING_MASS_FILL_SAVE_PATH, 'post', true, data)
}

export const JournalingService = new JournalingServiceClass()
